export const COLORS = {
  BRAND: '#006AFF',
  YELLOW400: '#F2A619',
  YELLOW600: '#8A5700',
  BLUE500: '#0D4599',
  LIGHTBLUE: '#E0F2FF',
  GRAY200: '#F1F1F4',
  GRAY300: '#D1D1D5',
  GRAY400: '#A6B3C4',
  TEXT_MEDIUM: '#596B82',
} as const;
